import React from "react";

const CheckBoxComp = React.forwardRef(({ label, title, className, ...props }, ref) => {
  return (
    <div className="row">
      <label
        style={{ display: 'flex', alignItems: 'center' }}
        title={title}
        className={className}
      >
        <input
          type="checkbox"
          ref={ref}
          style={{ marginRight: '0.5rem', cursor: 'pointer' }}
          className="checkbox-square"
          title={title}
          {...props}
        />
        {label}
      </label>
    </div>
  );
});

export default CheckBoxComp;
